/**
 * @format
 */

import * as types from './actions';

const initialState = {
  // state used when task is being added
  addTaskLoading: false,
  addTaskError: null,

  // state used when task is being updated
  updateTaskLoading: false,
  updateTaskError: null,

  // delete task
  deleteTaskLoading: false,
  deleteTaskError: null,

  // task loading
  taskLoading: false,
  taskListLoadingState: false,

  // task error
  taskError: null,

  // task state with key of task_id & value of task object
  tasks: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    // Create Task
    case types.CREATE_TASK_LOADING:
      return Object.assign({}, state, {
        addTaskLoading: true,
        addTaskError: null,
      });

    case types.CREATE_TASK_FAILURE:
      return Object.assign({}, state, {
        addTaskLoading: false,
        addTaskError: payload,
      });

    case types.CREATE_TASK_SUCCESS:
      return Object.assign({}, state, {
        addTaskLoading: false,
        addTaskError: null,
        tasks:
          payload.task.parent_id === null
            ? {
                ...state.tasks,
                [payload.taskId]: payload.task,
              }
            : {
                ...state.tasks,
                [payload.task.parent_id]: {
                  ...state.tasks[payload.task.parent_id],
                  sub_tasks: (() => {
                    const existingSubTasks =
                      state.tasks[payload.task.parent_id].sub_tasks || [];
                    const subTaskIndex = existingSubTasks.findIndex(
                      sub => sub.id === payload.taskId
                    );

                    if (subTaskIndex !== -1) {
                      // Update existing sub-task
                      return existingSubTasks.map(sub =>
                        sub.id === payload.taskId ? payload.task : sub
                      );
                    } else {
                      // Add new sub-task
                      return [...existingSubTasks, payload.task];
                    }
                  })(),
                },
              },
      });

    // Get all task
    case types.GET_ALL_TASKS_LOADING:
      return Object.assign({}, state, {
        taskListLoadingState: true,
      });

    case types.GET_ALL_TASKS_FAILURE:
      return Object.assign({}, state, {
        taskListLoadingState: false,
        taskError: payload.message,
      });

    case types.GET_ALL_TASKS_SUCCESS:
      return Object.assign({}, state, {
        taskListLoadingState: false,
        taskError: null,
        tasks: {
          ...payload.tasks?.reduce((result, item) => {
            result[item.id] = state.tasks[item.id]
              ? {
                  ...state.tasks[item.id],
                  ...item,
                }
              : item;
            return result;
          }, {}),
        },
      });

    // Get task by Id
    case types.GET_TASK_LOADING:
      return Object.assign({}, state, {
        taskLoading: true,
        taskError: null,
      });
    case types.GET_TASK_FAILURE:
      return Object.assign({}, state, {
        taskLoading: false,
        taskError: payload.message,
      });
    case types.GET_TASK_SUCCESS:
      return Object.assign({}, state, {
        taskLoading: false,
        taskError: null,
        tasks: { ...state.tasks, [payload.task.id]: payload.task },
      });

    // Update tasks
    case types.UPDATE_TASK_LOADING:
      return Object.assign({}, state, {
        updateTaskLoading: true,
        updateTaskError: null,
      });
    case types.UPDATE_TASK_SUCCESS:
      return Object.assign({}, state, {
        taskListLoadingState: false,
        taskError: null,
        tasks: {
          ...state.tasks, // Keep previous state
          ...payload.tasks?.reduce((result, item) => {
            if (item.parent_id === null) {
              result[item.id] = state.tasks[item.id]
                ? {
                    ...state.tasks[item.id], // Preserve existing data
                    ...item, // Overwrite with updated fields
                  }
                : item;
            } else {
              const { parent_id } = item;
              const parentTask = state.tasks[parent_id] || {};
              const selectedSubTaskIndex = parentTask.sub_tasks.findIndex(
                sTask => sTask.id === item.id
              );
              parentTask.sub_tasks[selectedSubTaskIndex] = item;
              result[parent_id] = parentTask;
            }
            return result;
          }, {}),
        },
      });
    case types.UPDATE_TASK_FAILURE:
      return Object.assign({}, state, {
        updateTaskLoading: false,
        updateTaskError: payload.message,
      });

    default:
      return state;
  }
};
